import { Grid } from 'antd';
import { useSyncExternalStore } from 'react';

const wideHeaderQuery = '(min-width: 1900px)';

const getWideHeaderSnapshot = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(wideHeaderQuery).matches;

const subscribeToWideHeader = (onStoreChange: () => void) => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return () => undefined;
  }

  const mediaQuery = window.matchMedia(wideHeaderQuery);
  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', onStoreChange);
    return () => mediaQuery.removeEventListener('change', onStoreChange);
  }

  mediaQuery.addListener(onStoreChange);
  return () => mediaQuery.removeListener(onStoreChange);
};

/**
 * Shared responsive state for BO pages.
 *
 * Ant Design's `md` breakpoint starts at 768px. Everything below it is
 * treated as the touch-first mobile layout used by phones and narrow PWA
 * windows.
 */
export const useResponsive = () => {
  const screens = Grid.useBreakpoint();
  const hasWideHeader = useSyncExternalStore(
    subscribeToWideHeader,
    getWideHeaderSnapshot,
    () => false,
  );

  return {
    screens,
    isMobile: !screens.md,
    isTablet: Boolean(screens.md && !screens.xl),
    isCompactHeader: !hasWideHeader,
  };
};

export default useResponsive;
